var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 25.4732C19.207 25.5542 22.4153 25.3561 25.5882 24.8814C26.0999 24.7642 26.5786 24.533 26.9885 24.205C27.3984 23.8771 27.729 23.4609 27.9557 22.9874C27.9557 22.9874 29.0211 20.7382 29.0211 16.0032C29.0211 11.2682 27.9557 9.01911 27.9557 9.01911C27.7104 8.55916 27.374 8.15401 26.9669 7.82838C26.5599 7.50274 26.0908 7.26345 25.5882 7.12511C22.4153 6.65033 19.207 6.4523 15.9998 6.53325C12.7925 6.45231 9.58434 6.65035 6.4114 7.12513C5.89968 7.24232 5.42103 7.47351 5.0111 7.80145C4.60118 8.12939 4.27056 8.54562 4.0439 9.01913C4.0439 9.01913 2.97852 11.2682 2.97852 16.0032C2.97852 20.7382 4.0439 22.9874 4.0439 22.9874C4.28919 23.4473 4.62562 23.8525 5.03267 24.1781C5.43971 24.5038 5.90883 24.743 6.41141 24.8814C9.58435 25.3562 12.7926 25.5542 15.9998 25.4732V25.4732Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7832 19.222V12.7813C12.7832 12.643 12.8199 12.5072 12.8895 12.3878C12.9592 12.2684 13.0592 12.1695 13.1795 12.1014C13.2999 12.0333 13.4361 11.9983 13.5743 12.0001C13.7126 12.0018 13.8479 12.0402 13.9664 12.1113L19.3337 15.3317C19.4494 15.4011 19.5451 15.4993 19.6116 15.6167C19.6781 15.7341 19.713 15.8667 19.713 16.0016C19.713 16.1365 19.6781 16.2692 19.6116 16.3866C19.5451 16.504 19.4494 16.6022 19.3337 16.6716L13.9664 19.8919C13.8479 19.9631 13.7126 20.0015 13.5743 20.0032C13.4361 20.005 13.2999 19.97 13.1795 19.9019C13.0592 19.8337 12.9592 19.7349 12.8895 19.6155C12.8199 19.496 12.7832 19.3603 12.7832 19.222V19.222Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.75c5cadcce487883142331f1c0f0346e.svg";
export { ForwardRef as ReactComponent };